export const tokens = {
  purple900: '#2d1b4e',
  purple700: '#4a2570',
  purple600: '#6b3a8a',
  purple400: '#9b6bb5',
  purple200: '#c4aed4',
  purple100: '#e8d8f0',
  purple50: '#faf7fc',
  pink200: '#f5d5e8',
  white: '#ffffff',
} as const
